import { Component, signal, input, inject, ViewChild, ElementRef, HostListener, OnInit, model } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LocalstorageService } from '../../../core/services/essentials/localstorage.service';
import { ScrollService } from '../../../core/services/scroll/scroll.service';
import { HomePageSigninUrl } from '../../enums/app.enums';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-home-nav',
  imports: [TranslocoModule],
  templateUrl: './home-nav.html',
  styleUrl: './home-nav.scss'
})
export class HomeNav implements OnInit {
  environment = environment;
  private scrollService = inject(ScrollService)
  private transloco = inject(TranslocoService);
  private localStorage = inject(LocalstorageService);  

  isEligibleForPersonalHiring = input(false);
  isAuthenticated = input(false);
  isProUser = input<boolean | null>(null);
  isTenderClick = signal(false)
  showBanner = model(false)

  @ViewChild('postJobTooltip') postJobTooltip?: ElementRef<HTMLElement>;
  @ViewChild('postJobTrigger') postJobTrigger?: ElementRef<HTMLElement>;

  currentUrl = input('');
  stop = signal(false);
  activeLang = signal('');
  isShowPostJobTooltip = signal(false);

  ngOnInit(): void {
    const storedLang = this.localStorage.getItem('ln') || 'en';
    this.transloco.setActiveLang(storedLang);
    this.activeLang.set(storedLang);
    this.transloco.langChanges$.subscribe(lang => {
      this.activeLang.set(lang);
    });
  }

  toggleLang(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const newLang = isChecked ? 'bn' : 'en';
    this.transloco.setActiveLang(newLang);
    this.localStorage.setItem('ln', newLang);
  }

  onClickPostJob(event?: MouseEvent): void {
    event?.stopPropagation(); // prevents immediate document click close
    this.isShowPostJobTooltip.set(!this.isShowPostJobTooltip());
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent):void {
    if (!this.isShowPostJobTooltip()) return;

    const target = event.target as Node;
    const tooltipEl = this.postJobTooltip?.nativeElement;
    const triggerEl = this.postJobTrigger?.nativeElement;

    const clickedInsideTooltip = !!tooltipEl && tooltipEl.contains(target);
    const clickedOnTrigger = !!triggerEl && triggerEl.contains(target);

    if (clickedInsideTooltip || clickedOnTrigger) return;

    this.isShowPostJobTooltip.set(false);
  }

  onTenderClick(): void{
    this.scrollService.updateTenderClick(true)
  }

  onClickContactUs(): void {
    const lang = this.transloco.getActiveLang(); 
    const url =
      lang === 'bn'
        ? 'https://bdjobs.com/bn/contactbn.asp?lanset=eng'
        : 'https://bdjobs.com/contact.asp?lanset=eng';
    window.open(url, '_blank');
  }

  expertSearchRedirect():void{
    if(this.isAuthenticated()){
      window.open('https://www.bdjobs.com/talent-search-dashboard/')
    }
    else{
      window.open(HomePageSigninUrl,'_self')
    }
  }
  
}
